// extracted by mini-css-extract-plugin
export default {"gap":".5em","theme":"#28a86e"};